import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCommentDots } from '@fortawesome/free-solid-svg-icons/faCommentDots'

const startChat = () =>
  // eslint-disable-next-line no-undef
  Verloop(function() {
    this.openWidget()
  })

export default class extends Component {

  constructor(props) {
    super(props);
    this.state = { show: false, width: 0, height: 0 }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll(){
    const { show } = this.state

    if (window.scrollY > 600) {
      if (!show) {
        this.setState({ show: true })
      }
    } else if (show) {
      this.setState({ show: false })
    }
  }

  updateWindowDimensions(){
    this.setState({ width: window.innerWidth, height: window.innerHeight })
  }

  render() {
    const { render: childRender, prescrollRender } = this.props

    return (
      <>
        {this.state.show && childRender()}
        {!this.state.show && (
          <div className="main-chat">
            <FontAwesomeIcon
              icon={faCommentDots}
              className="icon-main-chat"
              onClick={startChat}
            />
          </div>
        )}
        {!this.state.show && prescrollRender != null && prescrollRender()}
        {!this.state.show && prescrollRender == null && <div />}
      </>
    )
  }
}
